module.exports = __webpack_public_path__ + "assets/images/glucose_g.ea94a4df.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/risks/glucose_g.png
// module id = 720
// module chunks = 1